<template>
  <div class="component-wrapper align-center pa-6">
    <div
      id="header"
      class="d-flex flex-column flex-md-row justify-space-between align-center"
    >
      <v-btn
        x-large
        rounded
        color="#626262"
        class="white--text order-md-first"
        to="/info"
      >
        <v-icon left x-large color="secondary">mdi-information</v-icon>
        Πληροφοριες
      </v-btn>

      <div
        id="logo"
        class="
          d-flex
          align-center
          font-weight-medium
          text-h6
          order-first
          mb-5 mb-md-0
        "
      >
        <img
          src="../assets/oropos-logo.png"
          alt="oropos-logo"
          class="mr-3"
          style="height: 60px"
        />
        Δήμος Ωρωπού
      </div>
    </div>

    <div id="main" class="flex-1 d-flex flex-column mt-12">
      <div class="d-flex flex-column flex-md-row mb-12">
        <v-btn
          x-large
          class="rounded-lg white--text mr-0 mb-12 mr-md-12 mb-md-0"
          color="#F17D3C"
          to="/jukebox"
        >
          <img
            id="jukebox-icon"
            src="../assets/jukebox.png"
            alt="jukebox-logo"
            srcset=""
          />
          <span>JukeBox</span>
        </v-btn>

        <v-btn x-large class="rounded-lg" color="secondary" to="/search-music">
          <v-icon left>mdi-magnify</v-icon>
          <span> ΑΝΑΖΗΤΗΣΗ ΜΟΥΣΙΚΗΣ </span>
        </v-btn>
      </div>

      <div class="d-flex flex-column flex-md-row">
        <v-btn
          x-large
          class="rounded-lg white--text mr-0 mb-12 mr-md-12 mb-md-0"
          color="#953FD9"
          to="/sources"
        >
          <v-icon left>mdi-book</v-icon>
          <span>Πηγες για θεματα μουσικης</span>
        </v-btn>

        <v-btn
          x-large
          class="rounded-lg white--text"
          color="red lighten-1"
          to="/how-to-search"
        >
          <v-icon left>mdi-help</v-icon>
          <span>Πως αναζητω μουσικη στο διαδικτυο</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.component-wrapper {
  justify-content: flex-start;
}

.v-btn.v-size--x-large {
  padding: 30px 35px !important;
  font-size: 1.5rem !important;

  .v-icon--left {
    margin-right: 16px !important;
  }
  .v-icon--right {
    margin-left: 16px !important;
  }
}

#header {
  width: 100%;
}

@media screen and (min-width: 950px) {
  #main {
    padding-top: 5% !important;
  }
}

#main {
  // justify-content: center;

  .v-btn {
    width: 350px !important;
    height: 150px !important;

    .v-icon {
      width: 85px !important;

      &::before {
        font-size: 85px !important;
      }
    }

    .v-btn__content {
      span {
        justify-items: start !important;
        max-width: 200px !important;
        white-space: normal;
        text-align: start;
      }

      #jukebox-icon {
        width: 85px;
        margin-right: 16px;
        margin-left: -8px;
      }
    }
  }
}
</style>
